const article_sidebar = document.getElementById('article-sidebar');
if (article_sidebar && window.innerWidth <= 1024) {
	const main = document.getElementById('main-content');
	let scroll_btm = article_sidebar.getBoundingClientRect().bottom;
	let scroll_pos = scroll_btm + window.scrollY - article_sidebar.clientHeight;

	if (window.scrollY > 120 && scroll_pos < main.scrollHeight) {
		article_sidebar.style.opacity = 1;
		article_sidebar.style.visibility = 'visible';
	} else {
		article_sidebar.style.opacity = 0;
		article_sidebar.style.visibility = 'hidden';
	}
	document.addEventListener('scroll', () => {
		scroll_btm = article_sidebar.getBoundingClientRect().bottom;
		scroll_pos = scroll_btm + window.scrollY - article_sidebar.clientHeight;
		if (window.scrollY > 120 && scroll_pos < main.scrollHeight) {
			article_sidebar.style.opacity = 1;
			article_sidebar.style.visibility = 'visible';
		} else {
			article_sidebar.style.opacity = 0;
			article_sidebar.style.visibility = 'hidden';
		}
	});
}
